import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode,
}) => ([
  {
    path: '',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_layout" */ '@/pages/layout');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'layout',
          isLayout: true,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'layout',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'layout',
    index: undefined,
    id: 'layout',
    exact: true,
    exports: ["default"],
    layout: true,
    children: [{
      path: 'slim/hooks/useDeviceCheck',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-hooks-usedevicecheck" */ '@/pages/slim/hooks/useDeviceCheck');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/hooks/useDeviceCheck',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/hooks/useDeviceCheck',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-hooks-usedevicecheck',
      index: undefined,
      id: 'slim/hooks/useDeviceCheck',
      exact: true,
      exports: ["default","useDeviceCheck"],
    },{
      path: 'slim/hooks/useSeatRelease',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-hooks-useseatrelease" */ '@/pages/slim/hooks/useSeatRelease');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/hooks/useSeatRelease',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/hooks/useSeatRelease',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-hooks-useseatrelease',
      index: undefined,
      id: 'slim/hooks/useSeatRelease',
      exact: true,
      exports: ["default","useSeatRelease"],
    },{
      path: 'livekit/ParticipantTile',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_livekit-participanttile" */ '@/pages/livekit/ParticipantTile');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'livekit/ParticipantTile',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'livekit/ParticipantTile',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'livekit-participanttile',
      index: undefined,
      id: 'livekit/ParticipantTile',
      exact: true,
      exports: ["default"],
    },{
      path: 'slim/focus/overlayStack',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-focus-overlaystack" */ '@/pages/slim/focus/overlayStack');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/focus/overlayStack',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/focus/overlayStack',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-focus-overlaystack',
      index: undefined,
      id: 'slim/focus/overlayStack',
      exact: true,
      exports: ["OVERLAY_PRIORITY","registerOverlay","runTopOverlayBack","unregisterOverlay","useOverlayBack"],
    },{
      path: 'slim/utils/recordFormat',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-utils-recordformat" */ '@/pages/slim/utils/recordFormat');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/utils/recordFormat',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/utils/recordFormat',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-utils-recordformat',
      index: undefined,
      id: 'slim/utils/recordFormat',
      exact: true,
      exports: ["RECORD_MAX_MS","buildRecordFilename","formatClock","formatTimestamp"],
    },{
      path: 'voice-call/useVoiceCall',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_voice-call-usevoicecall" */ '@/pages/voice-call/useVoiceCall');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'voice-call/useVoiceCall',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'voice-call/useVoiceCall',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'voice-call-usevoicecall',
      index: undefined,
      id: 'voice-call/useVoiceCall',
      exact: true,
      exports: ["useVoiceCall"],
    },{
      path: 'slim/utils/useRemToPx',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-utils-useremtopx" */ '@/pages/slim/utils/useRemToPx');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/utils/useRemToPx',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/utils/useRemToPx',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-utils-useremtopx',
      index: undefined,
      id: 'slim/utils/useRemToPx',
      exact: true,
      exports: ["default","useRemToPx"],
    },{
      path: 'tele-monitoring',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_tele-monitoring-index" */ '@/pages/tele-monitoring/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'tele-monitoring',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'tele-monitoring',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'tele-monitoring-index',
      index: true,
      id: 'tele-monitoring',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'slim/focus/FocusRing',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-focus-focusring" */ '@/pages/slim/focus/FocusRing');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/focus/FocusRing',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/focus/FocusRing',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-focus-focusring',
      index: undefined,
      id: 'slim/focus/FocusRing',
      exact: true,
      exports: ["default"],
    },{
      path: 'slim/focus/useG29Nav',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-focus-useg29nav" */ '@/pages/slim/focus/useG29Nav');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/focus/useG29Nav',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/focus/useG29Nav',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-focus-useg29nav',
      index: undefined,
      id: 'slim/focus/useG29Nav',
      exact: true,
      exports: ["useG29Nav"],
    },{
      path: 'login-success',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-success-index" */ '@/pages/login-success/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'login-success',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'login-success',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-success-index',
      index: true,
      id: 'login-success',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'voice-call',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_voice-call-index" */ '@/pages/voice-call/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'voice-call',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'voice-call',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'voice-call-index',
      index: true,
      id: 'voice-call',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'slim/focus/dom',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-focus-dom" */ '@/pages/slim/focus/dom');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim/focus/dom',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim/focus/dom',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-focus-dom',
      index: undefined,
      id: 'slim/focus/dom',
      exact: true,
      exports: ["FOCUSABLE_SELECTOR","collectFocusables","ensureInView","findTopMask","isFocusRelevantMutation","isIgnored","moveFocus","nearestTo"],
    },{
      path: 'livekit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_livekit-index" */ '@/pages/livekit/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'livekit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'livekit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'livekit-index',
      index: true,
      id: 'livekit',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'success',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_success-index" */ '@/pages/success/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'success',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'success',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'success-index',
      index: true,
      id: 'success',
      exact: true,
      exports: ["default"],
    },{
      path: 'login',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-index" */ '@/pages/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-index',
      index: true,
      id: 'login',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'main',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_main-index" */ '@/pages/main/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'main',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'main',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'main-index',
      index: true,
      id: 'main',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'slim',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_slim-index" */ '@/pages/slim/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'slim',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'slim',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'slim-index',
      index: true,
      id: 'slim',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'pad',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_pad-index" */ '@/pages/pad/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'pad',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'pad',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'pad-index',
      index: true,
      id: 'pad',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: '',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index',
      index: true,
      id: '/',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: '*',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_$" */ '@/pages/$');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: '$',
      index: undefined,
      id: '*',
      exact: true,
      exports: ["default"],
    },]
  },{
    path: '/login',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-index" */ '@/pages/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'login-index',
    index: undefined,
    id: '/login',
    exact: true,
    exports: ["default","pageConfig"],
  },{
    path: '/livekit/*',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/livekit/*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/livekit/*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'index',
    index: undefined,
    id: '/livekit/*',
    exact: true,
    exports: ["default","pageConfig"],
  },
]);
export default createRoutes;
